<template>
  <div class="underwrite-order-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'UnderwriteOrderIndex'
}
</script>

<style lang="less" scoped>
.underwrite-order-container {
  padding: 20px;
  height: 100%;
}
</style>
